import { useForm } from '@inertiajs/react'
import Logo from '../../components/Logo'
import { useLocale } from '../../lib/LocaleContext'

export default function Login({ flash }) {
  const { t } = useLocale()
  const { data, setData, post, processing } = useForm({
    email: '',
    password: '',
  })

  function handleSubmit(e) {
    e.preventDefault()
    post('/login')
  }

  return (
    <div className="min-h-screen bg-zinc-900 flex items-center justify-center px-4 relative overflow-hidden">
      {/* Atmospheric glow behind logo */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[500px] h-[500px] rounded-full bg-emerald-900/8 blur-3xl" />
      </div>
      <div className="absolute inset-0 flex items-start justify-center pt-24 pointer-events-none">
        <div className="w-[300px] h-[300px] rounded-full bg-indigo-900/6 blur-3xl" />
      </div>

      <div className="w-full max-w-sm relative z-10">
        {/* Wordmark */}
        <div className="mb-10 flex flex-col items-center">
          <Logo variant="full" size={300} transparent />
        </div>

        {/* Alert */}
        {flash?.alert && (
          <div className="mb-4 px-4 py-2 bg-red-950 border border-red-800 rounded-lg text-sm text-red-400 font-mono">
            {flash.alert}
          </div>
        )}

        {/* Form card */}
        <div className="bg-zinc-800/30 border border-zinc-600/50 rounded-2xl p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-[10px] font-mono text-zinc-500 mb-1.5 uppercase tracking-widest">
                {t('auth.login.email')}
              </label>
              <input
                type="email"
                value={data.email}
                onChange={e => setData('email', e.target.value)}
                className="w-full bg-zinc-800/60 border border-zinc-600/60 rounded-lg px-3 py-2.5 text-sm font-mono text-zinc-100 placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/40 focus:border-emerald-600 transition-colors"
                placeholder={t('auth.login.email_placeholder')}
                required
                autoFocus
              />
            </div>

            <div>
              <label className="block text-[10px] font-mono text-zinc-500 mb-1.5 uppercase tracking-widest">
                {t('auth.login.password')}
              </label>
              <input
                type="password"
                value={data.password}
                onChange={e => setData('password', e.target.value)}
                className="w-full bg-zinc-800/60 border border-zinc-600/60 rounded-lg px-3 py-2.5 text-sm font-mono text-zinc-100 placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/40 focus:border-emerald-600 transition-colors"
                placeholder={t('auth.login.password_placeholder')}
                required
              />
            </div>

            <button
              type="submit"
              disabled={processing}
              className="w-full bg-emerald-800/60 hover:bg-emerald-700/80 disabled:opacity-50 disabled:cursor-not-allowed text-emerald-200 border border-emerald-700/40 font-mono text-sm font-semibold py-2.5 px-4 rounded-lg transition-colors mt-2"
            >
              {processing ? t('auth.login.submitting') : t('auth.login.submit')}
            </button>
          </form>
        </div>

        <p className="mt-6 text-center text-[10px] font-mono text-zinc-500 tracking-wider uppercase">
          {t('auth.login.tagline')}
        </p>
      </div>
    </div>
  )
}
